import { userHasAuth } from "@/middlewares";
import Vue from "vue";
import VueRouter from "vue-router";
import userRoutes from "@/views/User/router";
import plansRoutes from "@/views/Plans/router";
import ebooksRoutes from "@/views/Ebooks/router";
import blogRoutes from "@/views/Blog/router";
import meditationRoutes from "@/views/Meditation/router";
import humorRoutes from "@/views/Humor/router";
import polityRoutes from "@/views/Polity/router";
import manageRoutes from "@/views/Manage/router";
import professionalRoutes from "@/views/Professional/router";
import contentPagesRoutes from "@/views/Content/router";
import companyRoutes from "@/views/Company/router";

Vue.use(VueRouter);

const baseRoutes = [
  {
    path: "/404",
    name: "Page404",
    component: () => import(/* webpackChunkName: "404" */ "@/views/404"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];

// CONCAT ROUTES
const routes = baseRoutes.concat(
  userRoutes,
  plansRoutes,
  ebooksRoutes,
  blogRoutes,
  meditationRoutes,
  humorRoutes,
  polityRoutes,
  manageRoutes,
  professionalRoutes,
  contentPagesRoutes,
  companyRoutes
);

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    } else {
      window.scrollTo(0, 0);
    }
  },
});

router.beforeEach(async (to, from, next) => {
  const pageUnprotected = ["Login", "Polity", "Terms", "DeleteAccount", "DeleteAccountSalonDate", "Welcome"];

  if (pageUnprotected.indexOf(to.name) === -1) {
    await userHasAuth(to, from, next);
  } else {
    next();
  }
});

// router.beforeResolve(async (to, from, next) => {
//   const pageUnprotected = ["Login", "Welcome"];

//   if(to.meta.requiresAuth){
//     try {
//       await
//     }
//     // await userHasAuth(to, from, next)
//   }else{
//     next();
//   }
// });

export default router;
